import type { FormattedText } from '../utils';
import type { UniclientBaseComponentProps, UniclientWizardComponentBase } from './types';

export const analysisCompleteKey = 'analysisComplete';

export enum AnalysisItemStatus {
  Passed = 'passed',
  Discounted = 'discounted',
  Warning = 'warning',
}

export enum AnalysisItemDuration {
  Long = 'long',
  Short = 'short',
}

interface BaseAnalysisItem<TType extends string> {
  readonly type?: TType;
  readonly duration?: `${AnalysisItemDuration}`;
  readonly content:
    | FormattedText
    | {
        readonly name: string;
        readonly value: string;
      };
}

export interface RegularAnalysisItem extends BaseAnalysisItem<'item'> {
  readonly status: `${AnalysisItemStatus}`;
}

export type SummaryAnalysisItem = BaseAnalysisItem<'summary'>;

export type AnalysisItem = RegularAnalysisItem | SummaryAnalysisItem;

export function isRegularAnalysisItem(item: AnalysisItem): item is RegularAnalysisItem {
  return item.type === 'item' || item.type == null;
}

export interface AnalysisProps extends UniclientBaseComponentProps {
  readonly items: AnalysisItem[];
  readonly summary?: AnalysisItem;
  readonly shouldSubmitOnComplete?: boolean;
}

export type WizardAnalysisProps = AnalysisProps & UniclientWizardComponentBase<'analysis'>;

export function analysis(props: AnalysisProps): WizardAnalysisProps {
  return { ...props, type: 'analysis' };
}
